// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-icon_wrapper__TL\\+mQ {
  display: flex;
  align-items: center;
  background-color: var(--light-background-color);
  border-radius: 4px;
}

.input-icon_icon__mtJs2 {
  margin: 10px;
}

.input-icon_input__1KhYE input {
  width: 100%;
  padding: 12px;
  font-size: 14px;
  border: 0;
  background-color: var(--light-background-color);
  border-radius: 6px;
  box-sizing: border-box;
  font-weight: 800;
  height: 40px;
  max-width: 70px;
  text-align: end;

  &:focus-visible {
    outline: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/functional/input-icon.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,SAAS;EACT,+CAA+C;EAC/C,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;;EAEf;IACE,aAAa;EACf;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  background-color: var(--light-background-color);\n  border-radius: 4px;\n}\n\n.icon {\n  margin: 10px;\n}\n\n.input input {\n  width: 100%;\n  padding: 12px;\n  font-size: 14px;\n  border: 0;\n  background-color: var(--light-background-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  font-weight: 800;\n  height: 40px;\n  max-width: 70px;\n  text-align: end;\n\n  &:focus-visible {\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `input-icon_wrapper__TL+mQ`,
	"icon": `input-icon_icon__mtJs2`,
	"input": `input-icon_input__1KhYE`
};
export default ___CSS_LOADER_EXPORT___;
